import React, { useState } from 'react';
import { loginUser } from '../api';

function Login({ onLogin, onGoToRegister, onGoToForgotPassword, notice }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await loginUser(email.trim(), password);
      if (result.success) {
        onLogin(result.user);
      } else {
        setError(result.error || 'Login failed');
      }
    } catch (err) {
      setError(err.error || 'Login failed. Please check your email and password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <p className="brand">My Weed Buddy</p>
      <h1>Sign In</h1>
      <p className="subtitle">Sign in to your account</p>

      {notice && <div className="success">{notice}</div>}
      {error && <div className="error">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
            autoFocus
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
          />
        </div>

        <button type="submit" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>

      <p className="footer-link">
        <button type="button" onClick={onGoToForgotPassword}>
          Forgot password?
        </button>
      </p>

      <p className="footer-link">
        Need an account?{' '}
        <button type="button" onClick={onGoToRegister}>
          Register
        </button>
      </p>
    </div>
  );
}

export default Login;
